module.exports = __webpack_public_path__ + "img/cy.2bcced01.svg";